import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useTranslation } from "react-i18next";

import { SubmissionButton } from "@thalamos/frontend";
import type { ExtendedVisionUser, UserId } from "@thalamos/vision-common";
import { tk } from "@thalamos/vision-common";

import { PopupDialog } from "../../Dialog/PopupDialog.js";
import { TypographyI18N } from "../../TypographyI18N/TypographyI18N.js";

export interface DeleteUserModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (userId: UserId) => Promise<void>;
  user: ExtendedVisionUser;
}

export function DeleteUserModal({
  open,
  onClose,
  onConfirm,
  user,
}: DeleteUserModalProps) {
  const { t } = useTranslation();
  return (
    <PopupDialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      disableDialogRootPadding={true}
    >
      <DialogTitle>{t("admin.users.deleteUser")}</DialogTitle>
      <DialogContent>
        <TypographyI18N
          translationKey={tk("admin.users.deleteUserAreYouSure")}
        />
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "space-between",
          px: 3,
        }}
      >
        <Button onClick={onClose} color="error" variant="outlined">
          {t("common.close")}
        </Button>

        <SubmissionButton
          onClick={() => onConfirm(user.id)}
          color="primary"
          variant="contained"
        >
          {t("admin.users.deleteUser")}
        </SubmissionButton>
      </DialogActions>
    </PopupDialog>
  );
}
